module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/icon_title_hibiscus_orange-56f796d1e6738cf7f6e4275c620de697.svg";